import { AllureLabourUtilizationStateTypes, AllureLabourUtilizationActionTypes } from "./AllureLabourUtilization.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: AllureLabourUtilizationStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const AllureLabourUtilizationReducer = (
  state: AllureLabourUtilizationStateTypes = INITIAL_STATE,
  action: any
): AllureLabourUtilizationStateTypes => {
  switch (action.type) {
    case AllureLabourUtilizationActionTypes.FETCH_ALL_ALLURE_LABOUR_UTILIZATION:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case AllureLabourUtilizationActionTypes.FETCH_ALL_ALLURE_LABOUR_UTILIZATION_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case AllureLabourUtilizationActionTypes.FETCH_ALL_ALLURE_LABOUR_UTILIZATION_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case AllureLabourUtilizationActionTypes.FETCH_ALL_ALLURE_LABOUR_UTILIZATION_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case AllureLabourUtilizationActionTypes.FETCH_ONE_ALLURE_LABOUR_UTILIZATION:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case AllureLabourUtilizationActionTypes.FETCH_ONE_ALLURE_LABOUR_UTILIZATION_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case AllureLabourUtilizationActionTypes.FETCH_ONE_ALLURE_LABOUR_UTILIZATION_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case AllureLabourUtilizationActionTypes.FETCH_ONE_ALLURE_LABOUR_UTILIZATION_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default AllureLabourUtilizationReducer;
